import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { LayoutsComponent } from './layouts.component';
import { OffSidebarComponent } from './off-sidebar/off-sidebar.component';
import { SharedModule } from '../shared/shared.module';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { LogoutComponentDialog } from './logout-dialog/logout.component';


@NgModule({
    declarations: [HeaderComponent,
        LayoutsComponent,
        OffSidebarComponent,
        SidemenuComponent,
        LogoutComponentDialog
    ],
    exports: [HeaderComponent, LayoutsComponent, OffSidebarComponent, LogoutComponentDialog],
    imports: [
        CommonModule,
        SharedModule
    ]
})
export class LayoutsModule { }
